import api from '../api/axios';

export interface LeaveRequest {
  id?: number;
  employee: number;
  leaveType: 'vacation' | 'sick' | 'personal' | 'unpaid' | 'maternity' | 'paternity';
  startDate: string;
  endDate: string;
  reason?: string;
  status?: 'pending' | 'approved' | 'rejected' | 'cancelled';
  approvedBy?: number;
  approvalDate?: string;
  rejectionReason?: string;
  totalDays?: number;
}

const LeaveRequestService = {
  getAll: (params?: any) => api.get('/leave-requests', { params }),
  getOne: (id: number) => api.get(`/leave-requests/${id}`),
  create: (data: LeaveRequest) => api.post('/leave-requests', { data }),
  update: (id: number, data: Partial<LeaveRequest>) => api.put(`/leave-requests/${id}`, { data }),
  delete: (id: number) => api.delete(`/leave-requests/${id}`),
  approve: (id: number, approvedBy: number | null) =>
    api.put(`/leave-requests/${id}`, {
      data: {
        status: 'approved',
        ...(approvedBy !== null && { approvedBy }),
        approvalDate: new Date().toISOString(),
      },
    }),
  reject: (id: number, rejectionReason: string) =>
    api.put(`/leave-requests/${id}`, {
      data: { status: 'rejected', rejectionReason },
    }),
};

export default LeaveRequestService;

